import React from 'react';

import featureService from '@services/feature.service';
import { coreTranslations } from 'translations';

import { ConferenceBridgeImage, LockboxImage, LookoutImage, SosImage } from '@components/GlobalSearch/Images';

const canViewInNGSE = access => {
    const { canManageAssetDataStore, usesNextGenSendingEngine } = access;

    return !usesNextGenSendingEngine() || canManageAssetDataStore();
};

export const tilesConfig = [
    {
        title: coreTranslations.ng_core_lookOut,
        description: coreTranslations.ng_core_lookOutDescription,
        path: '/lookout',
        icon: <LookoutImage color="primary" />,
        visible: access =>
            featureService.getFeature('lookOutIncidentsPage') && access.canViewLookOut() && canViewInNGSE(access)
    },
    {
        title: coreTranslations.ng_core_sos,
        description: coreTranslations.ng_core_sosDescription,
        path: '/sos',
        icon: <SosImage color="primary" />,
        visible: access => featureService.getFeature('sosIncidentsPage') && access.canViewSOS() && canViewInNGSE(access)
    },
    {
        title: coreTranslations.ng_core_conferenceBridge,
        description: coreTranslations.ng_core_conferenceBridgeDescription,
        path: '/conference-bridge',
        icon: <ConferenceBridgeImage color="primary" />,
        visible: access =>
            access.canManageInternalConferenceResponse() && featureService.getFeature('conferenceBridgePage')
    },
    {
        title: coreTranslations.ng_core_lockbox,
        description: coreTranslations.ng_core_lockboxDescription,
        path: '/lockbox',
        icon: <LockboxImage color="primary" />,
        visible: access => access.canViewLockBox() && featureService.getFeature('lockBoxPage')
    }
];
